// extracted by mini-css-extract-plugin
export default {"wrapper":"cA-z","button":"dA-z","alternate":"eA-z","disabled":"fA-z","paymentWarning":"gA-z","fadeIn":"hA-z"};